import React, { useState, useEffect } from "react";
import MainBodyModal from "./MainBodyModal";
import MainBodyBlockModal from "./MainBodyBlockModal";
import MainBodyModalGrouped from "./MainBodyModalGrouped";
import RateCanvas from "./RateCanvas";

import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  TableFooter,
  Paper,
  Typography,
} from "@mui/material";

import IconButton from "@mui/material/IconButton";
import {
  FirstPage,
  LastPage,
  KeyboardArrowLeft,
  KeyboardArrowRight,
} from "@mui/icons-material";

// Компонент пагинации (без изменений)
const TablePaginationActions = (props) => {
  const { count, page, totalpage, rowsPerPage, onPageChange } = props;

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "ArrowRight" && page < totalpage) {
        onPageChange(null, page + 1);
      }
      if (e.key === "ArrowLeft" && page > 1) {
        onPageChange(null, page - 1);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [page, totalpage, onPageChange]);

  if (totalpage <= 1) return null;

  const handleFirstPageButtonClick = (event) => onPageChange(event, 1);
  const handleBackButtonClick = (event) => onPageChange(event, page - 1);
  const handleNextButtonClick = (event) => onPageChange(event, page + 1);
  const handleLastPageButtonClick = (event) => onPageChange(event, totalpage);

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton onClick={handleFirstPageButtonClick} disabled={page === 1}>
        <FirstPage />
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={page === 1}>
        <KeyboardArrowLeft />
      </IconButton>
      <Typography variant="body2" component="span">
        {page}
      </Typography>
      <IconButton onClick={handleNextButtonClick} disabled={page >= totalpage}>
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= totalpage}
      >
        <LastPage />
      </IconButton>
      <Typography variant="body2" component="span">
        Всего:{totalpage}
      </Typography>
    </Box>
  );
};

const MainBody = ({
  responseFilmList,
  getDataFilmList,
  repeatLastFilmListRequest,
  getDataListChannels,
  blockStore,
  hideMetUid,
}) => {
  const [page, setPage] = useState(1);
  const [hoveredPoster, setHoveredPoster] = useState(null);
  const [hoverPosition, setHoverPosition] = useState({ top: 0, left: 0 });

  const [openModal, setOpenModal] = useState(false);
  const [selectedFormat, setSelectedFormat] = useState("");
  const [responseAPI, setResponseAPI] = useState();

  const [openGrouped, setOpenGrouped] = useState(false);
  const [groupedId, setGroupedId] = useState(0);
  const [groupedTitle, setGroupedTitle] = useState("title");

  const [openBlockModal, setOpenBlockModal] = useState(false);
  const [selectedMovieForBlock, setSelectedMovieForBlock] = useState(null);

  // ==================== useEffect ====================
  useEffect(() => {
    setPage(responseFilmList.data.pagination.currentPage);
  }, [responseFilmList.data.pagination]);

  useEffect(() => {
    setHoveredPoster(null);
  }, [responseFilmList]);

  const POSTER_WIDTH = 280;
  const POSTER_HEIGHT = 420;
  const OFFSET_X = -400;
  const OFFSET_Y = -200;
  const BOTTOM_MARGIN = 80;

  // ==================== Обработчики ====================
  const handleMouseEnter = (event, element) => {
    const rect = event.target.getBoundingClientRect();
    let top = rect.top + window.scrollY + OFFSET_Y;
    let left = rect.left + window.scrollX + OFFSET_X;

    const posterBottom = top + POSTER_HEIGHT;
    if (posterBottom > window.scrollY + window.innerHeight - BOTTOM_MARGIN) {
      top = window.scrollY + window.innerHeight - POSTER_HEIGHT - BOTTOM_MARGIN;
    }

    setHoverPosition({ top, left });
    setHoveredPoster(element.poster);
  };

  const handleMouseLeave = () => {
    setHoveredPoster(null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getDataFilmList(newPage);
  };

  const handleOpenModal = (format, element) => {
    setSelectedFormat(format);
    setResponseAPI(element);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedFormat("");
  };

  const handleOpenGrouped = (id, title) => {
    setGroupedId(id);
    setGroupedTitle(title);
    setOpenGrouped(true);
  };

  const handleCloseGrouped = () => {
    setOpenGrouped(false);
  };

  const handleOpenBlockModal = (element) => {
    setSelectedMovieForBlock(element);
    setOpenBlockModal(true);
  };

  const handleCloseBlockModal = () => {
    setOpenBlockModal(false);
    setSelectedMovieForBlock(null);
  };

  // ==================== Рендер ====================
  return (
    <Box sx={{ flex: 1, padding: 1 }}>
      <Typography variant="h6" align="center" gutterBottom>
        Список фильмов
      </Typography>

      <TableContainer component={Paper} sx={{ maxHeight: "calc(100% - 40px)" }}>
        <Table sx={{ borderCollapse: "collapse" }} stickyHeader>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
              <TableCell
                sx={{
                  width: "30px",
                  border: "1px solid rgba(224,224,224,1)",
                  fontWeight: "bold",
                }}
              >
                ID
              </TableCell>
              <TableCell
                sx={{
                  width: "30px",
                  border: "1px solid rgba(224,224,224,1)",
                  fontWeight: "bold",
                }}
              >
                Год
              </TableCell>
              <TableCell
                sx={{
                  maxWidth: 700,
                  minWidth: 700,
                  width: 700,
                  border: "1px solid rgba(224,224,224,1)",
                  fontWeight: "bold",
                }}
              >
                Рейтинги / Возраст / Название
              </TableCell>
              <TableCell
                sx={{
                  border: "1px solid rgba(224,224,224,1)",
                  fontWeight: "bold",
                  width: "80px",
                }}
              >
                Блоки
              </TableCell>
              <TableCell
                sx={{
                  border: "1px solid rgba(224,224,224,1)",
                  fontWeight: "bold",
                }}
              >
                Группировки
              </TableCell>
              <TableCell
                sx={{
                  width: "30px",
                  border: "1px solid rgba(224,224,224,1)",
                  fontWeight: "bold",
                }}
              >
                Сериал
              </TableCell>
              <TableCell
                sx={{
                  border: "1px solid rgba(224,224,224,1)",
                  fontWeight: "bold",
                }}
              >
                Качество
              </TableCell>
              <TableCell
                sx={{
                  maxWidth: 100,
                  minWidth: 100,
                  width: 100,
                  border: "1px solid rgba(224,224,224,1)",
                  fontWeight: "bold",
                }}
              >
                Жанр
              </TableCell>
              <TableCell
                sx={{
                  maxWidth: 100,
                  minWidth: 100,
                  width: 100,
                  border: "1px solid rgba(224,224,224,1)",
                  fontWeight: "bold",
                }}
              >
                Страна
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {responseFilmList.data.data.map((element, index) => {
              const params = new URLSearchParams({ id: element.id });
              const href = `/filmdata?${params.toString()}`;

              return (
                <TableRow
                  key={index}
                  sx={{
                    backgroundColor:
                      !hideMetUid && !element.met_uid ? "#E0F7FA" : "inherit",
                    height: "20px",
                    "& td, & th": { padding: "4px" },
                  }}
                >
                  <TableCell
                    sx={{
                      width: "30px",
                      border: "1px solid rgba(224,224,224,1)",
                    }}
                  >
                    {element.id}
                  </TableCell>
                  <TableCell
                    sx={{
                      width: "30px",
                      border: "1px solid rgba(224,224,224,1)",
                      color: element.year > 2023 ? "red" : "inherit",
                    }}
                  >
                    {element.year}
                  </TableCell>

                  <TableCell
                    onMouseEnter={(e) => handleMouseEnter(e, element)}
                    onMouseLeave={handleMouseLeave}
                    sx={{
                      maxWidth: 700,
                      minWidth: 700,
                      width: 700,
                      border: "1px solid rgba(224,224,224,1)",
                      padding: "0px",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <RateCanvas rates={element.rate} />
                      <a href={href} target="_blank" rel="noopener noreferrer">
                        {element.title}
                      </a>
                    </Box>
                  </TableCell>

                  {/* Новый столбец "Блоки" */}
                  <TableCell
                    sx={{
                      border: "1px solid rgba(224,224,224,1)",
                      textAlign: "center",
                      backgroundColor:
                        element.block !== 0 ? "#f5f5f3" : "transparent",
                    }}
                  >
                    <span
                      onClick={() => handleOpenBlockModal(element)}
                      style={{
                        cursor: "pointer",
                        fontWeight: "bold",
                        color: "#1976d2",
                      }}
                    >
                      ***
                    </span>
                  </TableCell>

                  {/* Группировки */}
                  <TableCell
                    sx={{
                      border: "1px solid rgba(224,224,224,1)",
                      textAlign: "center",
                    }}
                  >
                    <span
                      onClick={() =>
                        handleOpenGrouped(element.id, element.title)
                      }
                      style={{
                        cursor: "pointer",
                        textDecoration: "underline",
                        marginRight: "5px",
                      }}
                    >
                      ...
                    </span>
                    {element.bundle?.map((item, idx) => {
                      const [bundleId] = Object.keys(item);
                      return (
                        <span key={idx} style={{ marginRight: "5px" }}>
                          {bundleId}
                        </span>
                      );
                    })}
                  </TableCell>

                  <TableCell
                    sx={{
                      width: "30px",
                      border: "1px solid rgba(224,224,224,1)",
                    }}
                  >
                    {element.serial === true ? "сериал" : element.serial}
                  </TableCell>

                  <TableCell sx={{ border: "1px solid rgba(224,224,224,1)" }}>
                    {element.format?.map((item, idx) => (
                      <span
                        key={idx}
                        onClick={() => handleOpenModal(item.format, element)}
                        style={{
                          cursor: "pointer",
                          textDecoration: "underline",
                          marginRight: "5px",
                        }}
                      >
                        {item.format}
                      </span>
                    ))}
                  </TableCell>

                  <TableCell
                    sx={{
                      maxWidth: 100,
                      minWidth: 100,
                      width: 100,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      border: "1px solid rgba(224,224,224,1)",
                    }}
                  >
                    {element.genre.join(", ")}
                  </TableCell>

                  <TableCell
                    sx={{
                      maxWidth: 100,
                      minWidth: 100,
                      width: 100,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      border: "1px solid rgba(224,224,224,1)",
                    }}
                  >
                    {element.country.join(", ")}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>

          <TableFooter>
            <TableRow>
              <TableCell colSpan={9}>
                <TablePaginationActions
                  count={responseFilmList.data.pagination.total}
                  page={page}
                  onPageChange={handleChangePage}
                  totalpage={responseFilmList.data.pagination.totalPages}
                  rowsPerPage={responseFilmList.data.pagination.perPage}
                />
              </TableCell>
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>

      {/* Модалки */}
      {responseAPI && (
        <MainBodyModal
          openModal={openModal}
          handleCloseModal={handleCloseModal}
          responseAPI={responseAPI}
          selectedFormat={selectedFormat}
          repeatLastFilmListRequest={repeatLastFilmListRequest}
          getDataListChannels={getDataListChannels}
          hideMetUid={hideMetUid}
        />
      )}

      <MainBodyModalGrouped
        openGrouped={openGrouped}
        handleCloseGrouped={handleCloseGrouped}
        id={groupedId}
        title={groupedTitle}
        repeatLastFilmListRequest={repeatLastFilmListRequest}
        responseFilmList={responseFilmList}
      />

      <MainBodyBlockModal
        open={openBlockModal}
        handleClose={handleCloseBlockModal}
        movie={selectedMovieForBlock}
        blockStore={blockStore}
        repeatLastFilmListRequest={repeatLastFilmListRequest}
      />

      {/* Всплывающий постер */}
      {hoveredPoster && (
        <Box
          sx={{
            position: "absolute",
            top: hoverPosition.top,
            left: hoverPosition.left,
            backgroundColor: "#fff",
            padding: 1,
            boxShadow: 3,
            zIndex: 1000,
          }}
        >
          <img
            src={hoveredPoster}
            alt="Постер"
            width={POSTER_WIDTH}
            height={POSTER_HEIGHT}
          />
        </Box>
      )}
    </Box>
  );
};

export default MainBody;
